import { Box } from "@mui/material"
import { LandingPageNav } from "../../components/Landing-Page/Nav";
import { Element } from "react-scroll";
import { FirstPage } from "../../components/Landing-Page/FirstPage";
import { SecondPage } from "../../components/Landing-Page/SecondPage";
import { ThirdPage } from "../../components/Landing-Page/ThirdPage";
import { FourthPage } from "../../components/Landing-Page/FourthPage";
import { FifthPage } from "../../components/Landing-Page/FifthPage";
import { SixthPage } from "../../components/Landing-Page/SixthPage";
import { SeventhPage } from "../../components/Landing-Page/SeventhPage";
import { LandingFooter } from "../../components/Landing-Page/Footer";

export const LandingPage = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '', color: '#000', minHeight: '100vh', fontFamily: "Inter, sans-serif", }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box
                    sx={{
                        width: '100%',            // Full width for the outer container
                        position: 'sticky',
                        top: '0',
                        zIndex: '999',
                        backgroundColor: '#fff'    // White background
                    }}
                >
                    <Box
                        sx={{
                            width: '100vw',        // Full viewport width
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: '100%', md: '85%' },  // Adjusted inner container width
                            }}
                        >
                            <LandingPageNav />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: '100%', md: '100%' } }}>
                    <Element name='FirstPage'>
                        <FirstPage />
                    </Element>
                    <Element name="SecondPage">
                        <SecondPage />
                    </Element>
                    <Element name="ThirdPage">
                        <ThirdPage />
                    </Element>
                    <Element name="FourthPage">
                        <FourthPage />
                    </Element>
                    <Element name="FifthPage">
                        <FifthPage />
                    </Element>
                    <Element name="SixthPage">
                        <SixthPage />
                    </Element>
                    <Element name="SeventhPage">
                        <SeventhPage />
                    </Element>
                    <Element name="LandingFooter">
                        <LandingFooter />
                    </Element>
                </Box>
            </Box>
        </Box>
    );
}